import { UpdateTimeOffRequestRequest } from '../types/dto/update-time-off-request.dto';
import { TimeOffRequestFormValues } from '../validations/time-off-request-form.schema';
import { mapTimeOffWorkingDaysToDto } from './time-off-request-form-payload.mapper';

export const buildUpdateRequestPayload = ({
  requestId,
  values,
}: {
  requestId: number;
  values: TimeOffRequestFormValues;
}): UpdateTimeOffRequestRequest => ({
  requestId,
  timeOffTypeId: Number(values.timeOffTypeId),
  description: values.description.trim() || undefined,
  days: mapTimeOffWorkingDaysToDto(values.days),
  approverIds: values.approvers.map(approver => approver.id),
});
